// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownFilledSvg from "@fishx/icons-svg/es/asn/FileMarkdownFilled";
import FishxIcon from '../components/FishxIcon';

var FileMarkdownFilled = function FileMarkdownFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownFilledSvg
  }));
};

FileMarkdownFilled.displayName = 'FileMarkdownFilled';
export default React.forwardRef(FileMarkdownFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileMarkdownFilled.js
// module id = 2715
// module chunks = 0